<template>
  <div class="act-bg">
    <div class="act-header">
      <!--        <img class="act-main-title"-->
      <!--             :src="baseUrl+'vip-alert.png'"/>-->
      <img class="act-main-title" :src="baseUrl + 'title1.png'" />
      <img class="act-sub-title" :src="baseUrl + 'title2.png'" />
    </div>
    <div class="act-area" v-for="index in areaList">
      <img class="act-area-title" :src="baseUrl + index.titleBg">
      <div class="act-goodsInfo" v-for="item in goodsList" @click="toGoodsDetail(item.goodsId)">
        <img class="goodsImg" :src="baseUrl + item.goodsImg" alt="">
      </div>
    </div>
    <div class="act-main-footer">
      <img class="act-main-logo" :src="baseUrl + 'zsgo-logo.png'" />
      <div class="act-main-bg"></div>
    </div>
  </div>
</template>
<script>
import { getDetail } from '@/utils/api/vipEnjoyApi';
import { toGoodsDetail } from '@/utils/InteractionWithJs';
import { addLog } from "../../../utils/commonApi";
import {getUrlQueryValueByKey} from "@/utils/util";

export default {
  data() {
    return {
      baseUrl: "https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/app/h5act/20231111/lizeng/",
      areaList: [
        { "titleBg": "act-area-title.png" },
      ],
      goodsList: [
        {
          "goodsImg": "3528.png",
          "goodsId": 10554844
        },
        {
          "goodsImg": "3174.png",
          "goodsId": 10554846
        },
        {
          "goodsImg": "2796.png",
          "goodsId": 10554847
        },
        {
          "goodsImg": "348.png",
          "goodsId": 10875194
        },
        {
          "goodsImg": "xinzeng.png",
          "goodsId": 10875760
        },
      ]
    }
  },
  mounted() {
    // this.getDetail()
    const actId = getUrlQueryValueByKey(location.href, "actId") || getUrlQueryValueByKey(location.href, "pageFlg") || '';
    const accessRefer = getUrlQueryValueByKey(location.href, "accessRefer") || '';
    //埋点
    addLog(accessRefer, '23-11-1', actId);
  },
  methods: {
    toGoodsDetail(goodsId) {
      toGoodsDetail(0,goodsId)
    },
    async getDetail() {
      const { errno, data, errmsg } = await getDetail();
      if (!errno) {
        this.goodsList = data
      }
    }
  }
}
// document.title = '订阅会员尊享';
</script>
<style scoped>
.act-bg {
  background-image: url("https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/app/h5act/20231111/lizeng/bg.png");
  width: 100%;
  background-size: 100%;
  background-repeat: no-repeat;
  min-height: 100vh;
  z-index: 0;
}

.act-header {
  width: 80%;
  margin-left: 10%;
}


.act-main-title {
  margin-top: .2rem;
  width: 6.18rem;
}

.act-sub-title {
  width: 5.62rem;
}

.act-area {
  position: relative;
  width: 100%;
  padding-bottom: 10px;
  padding-top: 10px;
  margin-top: .6rem;
  z-index: 1;
}

.act-area::before {
  content: "";
  position: absolute;
  top: 0;
  left: 5px;
  /* distance to the left side */
  right: 5px;
  /* distance to the right side */
  bottom: 0;
  background-color: rgba(187, 28, 34, 0.7);
  border-radius: 5px;
  z-index: -1;
}

.act-area .act-area-title {
  width: 4.32rem;
  /* height: 24px; */
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
}

.act-goodsInfo {
  margin: .1rem auto;
}

.act-goodsInfo .goodsImg {
  width: 95%;
}

.act-goodsInfo .goodsName {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  font-size: 14px;
  margin-bottom: .1rem;
}

.act-goodsInfo .goodsValue {
  color: #666;
  font-size: 10px;
  margin-bottom: .5rem;
}

.act-goodsInfo .goodsPart {
  display: flex;
  align-items: center;
  position: relative;
}

.act-goodsScore {
  margin-right: .2rem;
  color: #ff9000;
}

.act-goodsScore img {
  width: .18rem;
  height: .19rem;
}

.act-main-footer {
  /* margin-top: -.5rem; */
  width: 100%;
  position: relative;
}

.act-main-footer .act-main-logo {
  width: 16%;
  position: absolute;
  /* Enable absolute positioning relative to .act-main-footer */
  top: 50%;
  /* Place the upper edge of the element in the center of .act-main-footer */
  left: 50%;
  /* Place the left edge of the element in the center of .act-main-footer */
  transform: translate(-50%, -50%);
}

.act-main-footer .act-main-bg {
  width: 100%;
  height: 2.2rem;
}</style>
